(function () {
  const VIEWPORT_MARGIN = 16;
  const MOBILE_BREAKPOINT = 750;

  function positionPanel(group) {
    const panel = group.querySelector('.color-blocks__panel');
    if (!panel) return;

    const viewportWidth = document.documentElement.clientWidth;
    const isMobile = viewportWidth < MOBILE_BREAKPOINT;
    const isCols5 = panel.querySelector('.color-blocks__sublist--cols-5') != null;
    const list = group.closest('.color-blocks__list');

    panel.style.removeProperty('width');

    let shift = 0;

    if (isMobile && isCols5 && list) {
      const listRect = list.getBoundingClientRect();
      const groupRect = group.getBoundingClientRect();
      const panelWidth = listRect.width;

      panel.style.width = `${Math.round(panelWidth)}px`;
      shift = listRect.left - groupRect.left - groupRect.width / 2 + panelWidth / 2;
    } else {
      const margin = isMobile ? 12 : VIEWPORT_MARGIN;

      for (let i = 0; i < 3; i += 1) {
        panel.style.setProperty('--color-blocks-panel-shift', `${Math.round(shift)}px`);
        const rect = panel.getBoundingClientRect();
        let nextShift = shift;

        if (rect.left < margin) nextShift += margin - rect.left;
        if (rect.right > viewportWidth - margin) nextShift += viewportWidth - margin - rect.right;

        if (nextShift === shift) break;
        shift = nextShift;
      }
    }

    panel.style.setProperty('--color-blocks-panel-shift', `${Math.round(shift)}px`);
  }

  function schedulePositionPanel(group) {
    requestAnimationFrame(() => {
      positionPanel(group);
      requestAnimationFrame(() => positionPanel(group));
    });
  }

  function onPanelTrigger(event) {
    const group = event.target.closest?.('.color-blocks__group');
    if (group) schedulePositionPanel(group);
  }

  document.addEventListener('pointerover', onPanelTrigger);
  document.addEventListener('focusin', onPanelTrigger);
  document.addEventListener('pointerdown', onPanelTrigger);
})();
